class PivotInvoiceForm extends HTMLElement {
  constructor() {
    super();
    // Estado interno
    this._state = { mode: "save", isValid: false, isEmpty: true };

    // Selectores de inputs y elementos
    this.$rutInput = this.querySelector('input[name="attributes[RUTEmpresa]"]');
    this.$regionSelector = this.querySelector(
      'select[name="attributes[Region]"]',
    );
    this.$communeSelector = this.querySelector(
      'select[name="attributes[Comuna]"]',
    );
    this.$button = this.querySelector("#pivot-invoice-save");
    this.$rutErrorMessage = this.querySelector(".rut-error-message");
    this.$details = this.querySelector("details");
    this.$summary = this.querySelector(".pivot-invoice-summary");
    this.$summaryValue = this.querySelector("[data-summary-value]");

    // Selectores de Radio Buttons (Boleta / Factura)
    this.$boletaOption = this.querySelector("#boleta-option");
    this.$invoiceOption = this.querySelector("#invoice-option");

    // Mapeo de regiones
    const mappingScript = this.querySelector("#pivot-invoice-regions-mapping");
    this.$regionsMapping = mappingScript
      ? JSON.parse(mappingScript.textContent)
      : {};
    this.hasSavedInvoice = this.dataset.hasInvoice === "true";
    this.forceExpanded = false;
    this.initEvents();

    // Lógica inicial de apertura y carga de datos
    if (this.hasSavedInvoice) {
      this.$invoiceOption.checked = true;
      this.$details.open = false;
      this._state.mode = "clear";
    }
    this.handleRegionChange();

    // Restaurar comuna si existe
    if (this.$communeSelector.dataset.value) {
      setTimeout(() => {
        this.$communeSelector.value = this.$communeSelector.dataset.value;
        this.checkFormState(true);
      }, 50);
    } else {
      this.checkFormState(true);
    }
  }
  getCheckoutButtons() {
    return [
      document.querySelector("#CartDrawer-Checkout"),
      document.querySelector("#checkout"),
    ].filter(Boolean);
  }

  onStateChange = () => {
    // 1. Lógica del botón interno (Guardar)
    if (this.$button) {
      // Si ya está guardado (mode clear) o el form es inválido, se deshabilita
      this.$button.disabled =
        this._state.mode === "clear" || !this._state.isValid;
    }

    // 2. Lógica del botón de Checkout (Bloqueo si hay cambios sin guardar)
    const isFacturaSelected = this.$invoiceOption.checked;
    const isEditingUnsaved = this._state.mode === "save";
    const shouldDisable = isFacturaSelected && isEditingUnsaved;
    this.getCheckoutButtons().forEach(($btn) => {
      $btn.disabled = shouldDisable;
      if (shouldDisable) {
        $btn.style.opacity = "0.5";
        $btn.style.pointerEvents = "none";
        $btn.style.cursor = "not-allowed";
      } else {
        $btn.style.opacity = "";
        $btn.style.pointerEvents = "";
        $btn.style.cursor = "";
      }
    });
    // 3. Lógica de vista (resumen colapsado vs formulario)
    this.updateSummaryText();
    this.updateViewState();
  };

  initEvents = () => {
    // Escuchar cambios en todos los campos para validación
    this.querySelectorAll("input, select").forEach((el) => {
      if (el.name !== "invoice_type") {
        el.addEventListener("input", () => this.checkFormState(false));
        el.addEventListener("change", () => this.checkFormState(false));
      }
    });

    // Control de apertura por Radio Buttons
    this.$boletaOption.addEventListener("change", () => {
      if (this.$boletaOption.checked) {
        this.$details.open = false;
        this.forceExpanded = false;
        this.handleClear(); // Al pasar a boleta, limpiamos datos en el servidor
      }
    });

    this.$invoiceOption.addEventListener("change", () => {
      if (this.$invoiceOption.checked) {
        this.$details.open = true;
        this.checkFormState(false);
      }
    });

    this.$regionSelector.addEventListener("change", this.handleRegionChange);
    this.$rutInput.addEventListener("blur", this.handleRutChange);
    this.$rutInput.addEventListener("keyup", () => this.checkFormState(false));

    // Botón Guardar
    this.$button.addEventListener("click", (e) => this.handleSubmit(e));

    if (this.$summary) {
      this.$summary.addEventListener("click", () => this.expandForm());
    }
  };

  expandForm = () => {
    if (!this.$invoiceOption.checked) {
      this.$invoiceOption.checked = true;
    }

    this.forceExpanded = true;
    this.$details.open = true;
    this.setCollapsed(false);
  };

  setCollapsed = (isCollapsed) => {
    if (!this.$summary) return;
    this.dataset.collapsed = isCollapsed ? "true" : "false";
    this.$summary.setAttribute("aria-expanded", isCollapsed ? "false" : "true");
  };

  updateSummaryText = () => {
    if (!this.$summaryValue) return;
    const rawValue = this.$rutInput ? this.$rutInput.value : "";
    const trimmed = rawValue ? rawValue.trim() : "";
    this.$summaryValue.textContent = trimmed;
  };

  updateViewState = () => {
    const isFacturaSelected = this.$invoiceOption.checked;
    const shouldCollapse =
      this.hasSavedInvoice &&
      this._state.mode === "clear" &&
      isFacturaSelected &&
      !this.forceExpanded;
    if (shouldCollapse) {
      this.$details.open = false;
      this.setCollapsed(true);
      return;
    }
    this.setCollapsed(false);
    this.$details.open = isFacturaSelected;
  };

  checkFormState = (isInitial = false) => {
    const inputs = [
      this.$rutInput,
      this.$regionSelector,
      this.$communeSelector,
      this.querySelector("#RazonSocial"),
      this.querySelector("#Giro"),
      this.querySelector("#DireccionEmpresa"),
    ].filter((el) => el !== null);

    const allEmpty = inputs.every(
      (input) => !input.value || input.value.trim() === "",
    );
    const hasEmptyRequired = inputs.some(
      (input) => input.hasAttribute("required") && !input.value,
    );
    const isRutValid =
      !this.$rutInput.value || validateRut(this.$rutInput.value);
    this._state.isValid = !hasEmptyRequired && isRutValid;
    this._state.isEmpty = allEmpty;

    // Si es carga inicial y hay datos, estamos en modo 'clear' (guardado)
    if (isInitial && !allEmpty) {
      this._state.mode = "clear";
    } else if (!isInitial) {
      this._state.mode = "save";
      if (this.$invoiceOption.checked) {
        this.forceExpanded = true;
      }
    }
    this.onStateChange();
  };

  handleRegionChange = () => {
    const region = this.$regionSelector.value;
    const communes = this.$regionsMapping[region] || [];
    const currentCommune = this.$communeSelector.value;
    let options = `<option value="">Selecciona una comuna</option>`;
    if (communes.length > 0) {
      options += communes
        .map((c) => `<option value="${c}">${c}</option>`)
        .join("");
    }
    this.$communeSelector.innerHTML = options;

    if (communes.includes(currentCommune)) {
      this.$communeSelector.value = currentCommune;
    }
  };

  handleRutChange = () => {
    const val = this.$rutInput.value;
    if (val === "" || validateRut(val)) {
      this.$rutErrorMessage.classList.remove("show");
      this.$rutInput.setCustomValidity("");
      this.$rutInput.value = formatDNI({ rut: val, pais: "CL" });
    } else {
      this.$rutErrorMessage.classList.add("show");
      this.$rutInput.setCustomValidity("RUT Inválido");
    }
    this.checkFormState(false);
    this.updateSummaryText();
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.$rutInput.value && !validateRut(this.$rutInput.value)) return;

    this.$button.textContent = "Guardando...";
    this.$button.disabled = true;

    // Obtener todos los valores de los campos de factura
    const formData = new FormData();
    const fields = [
      "RUTEmpresa",
      "RazonSocial",
      "Giro",
      "DireccionEmpresa",
      "Region",
      "Comuna",
    ];

    fields.forEach((field) => {
      const el = this.querySelector(`[name="attributes[${field}]"]`);
      if (el) formData.append(`attributes[${field}]`, el.value);
    });
    fetch("/cart/update.js", {
      method: "POST",
      body: formData,
    })
      .then(() => {
        this._state.mode = "clear";
        this.hasSavedInvoice = true;
        this.dataset.hasInvoice = "true";
        this.forceExpanded = false;
        this.syncToOtherForms(fields);
        this.onStateChange();
      })
      .finally(() => {
        this.$button.textContent = "Guardar";
      });
  };
  syncToOtherForms = (fields) => {
    document.querySelectorAll("pivot-invoice-form").forEach((otherForm) => {
      if (otherForm === this) return;
      fields.forEach((field) => {
        const source = this.querySelector(`[name="attributes[${field}]"]`);
        const target = otherForm.querySelector(`[name="attributes[${field}]"]`);
        if (!source || !target) return;
        if (field === "Region") {
          target.value = source.value;
          otherForm.handleRegionChange();
        } else if (field === "Comuna") {
          // Se aplica después de que handleRegionChange pobló las opciones
          target.value = source.value;
        } else {
          target.value = source.value;
        }
      });
      otherForm.$invoiceOption.checked = true;
      otherForm.hasSavedInvoice = true;
      otherForm.dataset.hasInvoice = "true";
      otherForm._state.mode = "clear";
      otherForm.forceExpanded = false;
      otherForm.checkFormState(true);
    });
  };

  syncClearToOtherForms = () => {
    document.querySelectorAll("pivot-invoice-form").forEach((otherForm) => {
      if (otherForm === this) return;

      otherForm.querySelectorAll("input, select").forEach((el) => {
        if (el.name !== "invoice_type") el.value = "";
      });

      otherForm.$boletaOption.checked = true;
      otherForm.hasSavedInvoice = false;
      otherForm.dataset.hasInvoice = "false";
      otherForm.forceExpanded = false;
      otherForm._state.mode = "save";
      otherForm.checkFormState(false);
    });
  };

  handleClear = () => {
    const attributes = {
      RUTEmpresa: null,
      RazonSocial: null,
      Giro: null,
      DireccionEmpresa: null,
      Region: null,
      Comuna: null,
    };

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes }),
    }).then(() => {
      this.querySelectorAll("input, select").forEach((el) => {
        if (el.name !== "invoice_type") el.value = "";
      });
      this.hasSavedInvoice = false;
      this.dataset.hasInvoice = "false";
      this.forceExpanded = false;
      this._state.mode = "save";
      this.syncClearToOtherForms();
      this.checkFormState(false);
    });
  };
}

if (!customElements.get("pivot-invoice-form")) {
  customElements.define("pivot-invoice-form", PivotInvoiceForm);
}

// --- Funciones de utilidad ---
function formatDNI({ rut, pais }) {
  if (!rut) return "";
  const regex = /[^\dkK]/g;
  rut = rut.toString().replace(regex, "");
  const dv = rut.slice(-1).toUpperCase();

  if (rut.length > 1) {
    rut = rut.slice(0, -1) + "-" + dv;
  }
  return rut;
}

function validateRut(rut) {
  if (!rut) return true;
  rut = rut.replace(/[^0-9kK]/g, "");
  if (rut.length < 8) return false;
  let cuerpo = rut.slice(0, -1);
  let dv = rut.slice(-1).toUpperCase();
  let suma = cuerpo
    .split("")
    .reverse()
    .reduce(
      (acc, digit, index) => acc + parseInt(digit) * ((index % 6) + 2),
      0,
    );
  let resultado = 11 - (suma % 11);
  let digitoVerificador =
    resultado === 11 ? "0" : resultado === 10 ? "K" : resultado.toString();
  return dv == digitoVerificador;
}
